/* eslint-disable no-unused-vars */
export enum TargetType {
  Bank = '4',
  MNOGetaway = '21',
  MNOProvider = '30',
  PayBills = '10',
  CashOut = '9',
}

export enum ActionType {
  Transfer = '1',
  PayBills = '2',
  TopUp = '3',
}

export enum DestType {
  CP = 'CP',
  OTHER = 'OTHER',
  SELF = 'SELF',
}

export enum GatewayType {
  MOBILE_TRANSFER = '30',
  ATM = '31',
  MERCHANT = '32',
  INVOICE_POSTPAID = '33',
  INVOICE_PREPAID = '34',
  TOP_UP = '35',
  BANK_TRANSFER = '36',
  PREPAID_CARD = '37',
}

export enum TransferSourceType {
  BANK = 'BANK',
  WALLET = 'WALLET',
  CashOut = 'CASH_OUT',
  MOBILE = 'MOBILE',
}

export enum PaymentReferenceType {
  PAY_BILLS = 'PAY_BILLS',
  LOCAL_TRANSFER = 'LOCAL_TRANSFER',
}
